module.exports = __webpack_public_path__ + "img/rtv_logo_WH_3840x2160px-p-3200.8a1acf47.png";